module.exports = __webpack_public_path__ + "img/icon_map_jgdk.a66e879c.png";